import React, { useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet'
import { Button, LinkInline } from '@dasa-health/alma-react'
import { Divider } from '@dasa-health/components-react'
import { BrandId, actionsText } from '@nsw-paginas-deslogadas/constants'
import { useAppContext } from '@nsw-paginas-deslogadas/store/useAppContext'
import { IsPageByBrandProduct, NavConteudoLinkBuilded, RedirectToCOABuilded } from '@nsw-paginas-deslogadas/utils'
import { Images, Logotypes, BrandMapping } from '@nsw-paginas-deslogadas/assets'
import Menu from './../Menu'
import * as S from './styles'
import { SEOProps } from '@nsw-paginas-deslogadas/typings/map'

export type dataAtributtesType = {
    'data-item-position': string
    'data-current-service': string
    'data-item-text': string
}

const Header: React.FC = () => {
    const { BlueNavDasaLogo } = Images
    const { brand, product } = useAppContext()

    const setSEOContent = ({ title, metaDescription }: SEOProps) => {
        window.document.title = title

        const originalMetaDescription = document.querySelector('meta[name="description"]')

        if (originalMetaDescription) {
            originalMetaDescription.setAttribute('content', metaDescription)
        } else {
            const meta = document.createElement('meta')
            meta.name = 'description'
            meta.content = metaDescription
            document.head.appendChild(meta)
        }
    }

    const mapping = useMemo(() => {
        const map = BrandMapping[brand.mappingId]

        if (map.lpDesignProps) {
            setSEOContent(map.lpDesignProps.foldPagePresentationBrand.seo)
        } else if (map.lpV1Seo) {
            setSEOContent(map.lpV1Seo)
        }

        return map
    }, [brand])

    const [foldPagePresentationBrandImage, setFoldPagePresentationBrandImage] = useState<string | undefined>()

    useEffect(() => {
        const brandSetting = BrandMapping[brand.mappingId]
        setFoldPagePresentationBrandImage(brandSetting.lpDesignProps?.foldPagePresentationBrand.backgroundImage.src)
    }, [brand, foldPagePresentationBrandImage])

    const productLabels = useMemo(() => (product.category?.id === 4 ? actionsText.vaccines : actionsText.exams), [product])

    const dataAtributtes = (dataText: string): dataAtributtesType => ({
        'data-item-position': 'Header',
        'data-current-service': IsPageByBrandProduct ? 'Página de Produto da Marca' : 'Página da Marca',
        'data-item-text': dataText,
    })

    return (
        <>
            <Helmet>
                <link as="image" href={foldPagePresentationBrandImage} rel="preload" />
            </Helmet>
            <S.Container>
                <img alt={BlueNavDasaLogo.alt} className="nav-logo" src={BlueNavDasaLogo.src} />
                {brand.mappingId !== BrandId.Nav && (
                    <>
                        <Divider className="header-divider" direction="vertical" />
                        <img alt={Logotypes[brand.mappingId].alt} className="brand-logo" src={Logotypes[brand.mappingId].src} />
                    </>
                )}

                <Menu dataAtributtes={dataAtributtes} showMenuAccount={true} />

                <S.HeaderContentContainer>
                    <LinkInline
                        className="header-item"
                        href={NavConteudoLinkBuilded}
                        target="_blank"
                        {...dataAtributtes('Hub de Conteúdo')}
                    >
                        Conteúdo
                    </LinkInline>
                    <LinkInline className="header-item" href={RedirectToCOABuilded} target="_blank" {...dataAtributtes('COA')}>
                        Consulta Online
                    </LinkInline>

                    {product?.category && (
                        <LinkInline
                            href={product.navigateTo}
                            sx={{ textDecoration: 'none' }}
                            target="_self"
                            {...dataAtributtes(productLabels.plural)}
                        >
                            <Button data-testid="btn-vaccines">{productLabels.single}</Button>
                        </LinkInline>
                    )}

                    {!product?.category && (
                        <>
                            {mapping.vaccine && (
                                <LinkInline
                                    data-testid="btn-vaccine"
                                    href={mapping.buttons.header.vaccines}
                                    sx={{ textDecoration: 'none' }}
                                    target="_self"
                                    {...dataAtributtes(actionsText.vaccines.plural)}
                                >
                                    {mapping.renderLPV2 ? (
                                        <Button
                                            className="vaccine-button"
                                            style={{
                                                background: mapping.lpDesignProps?.foldPagePresentationBrand.buttonBackgroundColor,
                                                color: mapping.lpDesignProps?.foldPagePresentationBrand.buttonTextColor,
                                            }}
                                        >
                                            {actionsText.vaccines.single}
                                        </Button>
                                    ) : (
                                        <Button className="vaccine-button">{actionsText.vaccines.single}</Button>
                                    )}
                                </LinkInline>
                            )}
                            <LinkInline
                                data-testid="btn-exam"
                                href={mapping.buttons.header.exams}
                                sx={{ textDecoration: 'none' }}
                                target="_self"
                                {...dataAtributtes(actionsText.exams.plural)}
                            >
                                {mapping.renderLPV2 ? (
                                    <Button
                                        style={{
                                            background: mapping.lpDesignProps?.foldPagePresentationBrand.buttonBackgroundColor,
                                            color: mapping.lpDesignProps?.foldPagePresentationBrand.buttonTextColor,
                                        }}
                                    >
                                        {actionsText.exams.single}
                                    </Button>
                                ) : (
                                    <Button>{actionsText.exams.single}</Button>
                                )}
                            </LinkInline>
                        </>
                    )}
                </S.HeaderContentContainer>
            </S.Container>
        </>
    )
}

export default Header
